import { takeEvery, put, call } from "redux-saga/effects";
import {
  FETCH_SHIFTS, CREATE_SHIFT, UPDATE_SHIFT, DELETE_SHIFT
} from "./actionTypes";
import {
  fetchShiftsSuccess, fetchShiftsFailure,
  createShiftSuccess, createShiftFailure,
  updateShiftSuccess, updateShiftFailure,
  deleteShiftSuccess, deleteShiftFailure,
  fetchShifts
} from "./actions";
import { post, update, del } from "../../../helpers/api_helper";
import Swal from "sweetalert2";
import { showToast, showConfirm } from "../../../common/Toaster";

// Fetch Shifts
function* fetchShiftsSaga(action) {
  try {
    const apiUrl = process.env.REACT_APP_GET_SHIFT_API;
    const formData = new FormData();
    formData.append("unit_id", action.payload.unitId);
    const response = yield call(post, apiUrl, formData);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve shifts!");
    }
    yield put(fetchShiftsSuccess(response));
  } catch (error) {
    yield put(fetchShiftsFailure(error.message));
  }
}

// Create Shift
function* createShiftSaga({ payload }) {
  try {
    const { formData, isEdit } = payload;
    const apiUrl = process.env.REACT_APP_SAVE_SHIFT_API;
    const response = yield call(post, apiUrl, formData);
    if (response?.status === "success") {
      showToast({ icon: response?.status, title: response?.status, text: response.message });
      yield put(createShiftSuccess(response));
      const unitId = formData.get("unit_id");
      if (unitId) {
        yield put(fetchShifts(unitId));
      } else {
        console.log("unit_id is missing in formData, fetch not triggered");
      }
    } else {
      showToast({ icon: "error", title: "Error", text: response.message });
      yield put(createShiftFailure(response));
    }
  } catch (error) {
    showToast({ icon: "error", title: "API Error", text: error.message });
    yield put(createShiftFailure(error.message));
  }
}

// Update Shift
function* updateShiftSaga({ payload }) {
  try {
    const response = yield call(update, `${process.env.REACT_APP_UPDATE_SHIFT_API}/${payload.id}`, payload);
    yield put(updateShiftSuccess(response));
  } catch (error) {
    yield put(updateShiftFailure(error.message));
  }
}

// Delete Shift
function* deleteShiftSaga({ payload }) {
  try {
    const apiUrl = process.env.REACT_APP_DELETE_SHIFT_API;
    const response = yield call(post, apiUrl, payload);
    if (response?.status === "success") {
      showToast({ icon: "success", title: "success", text: response.message });
      yield put(deleteShiftSuccess(response));
    }
    else {
      showToast({ icon: "error", title: "Error", text: response.message });
    }
    yield put(deleteShiftFailure(error.message));
  } catch (error) {
    showToast({ icon: "error", title: "API Error", text: error.message });
    yield put(deleteShiftFailure(error.message));
  }
}

// Watcher Saga
function* shiftSaga() {
  yield takeEvery(FETCH_SHIFTS, fetchShiftsSaga);
  yield takeEvery(CREATE_SHIFT, createShiftSaga);
  yield takeEvery(UPDATE_SHIFT, updateShiftSaga);
  yield takeEvery(DELETE_SHIFT, deleteShiftSaga);
}

export default shiftSaga;
